import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "src/app/services/storage.service";
import { DataBuilder } from "src/app/base/model/data-body-request";


@Injectable({
    providedIn: 'root',
})
export class BaseRepository {
    urlServices = environment.urlServiceCommon;

    constructor(
        protected storageService: StorageService
    ) {}

    public getOperationID(dataBuilder: DataBuilder) {
        let storageService = new StorageService()

        storageService.getStorage('originalOperationId').then((op: any) => {
            if (op.value) {
                console.log('originalOperationId to searchEnrollment');
                dataBuilder.buildOperationId(+op.value);
            } else {
                storageService.getStorage('operationID').then((p: any) => {
                    if (p.value !== null) {
                        console.log('operationID to searchEnrollment');
                        dataBuilder.buildOperationId(+p.value);
                    }
                });
            }
        });
    }

}